import FinsightModal from './FinsightModal';

export default FinsightModal;
